







































































import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      list: [
        {
          title: '申请条件',
          ques: '借款需要哪些基本条件？',
          ans: '提供本人身份证及银行卡，年龄≥23周岁的用户。',
          url: require('../../../assets/img/indexNew/01.png')
        },
        {
          title: '借款流程',
          ques: '如何申请借款？',
          ans: '通过好分期App提交所需审核材料，获取借款额度后，便可以操作借款。',
          url: require('../../../assets/img/indexNew/02.png')
        },
      ]
    };
  },
  methods: {},
});
